import React from 'react';

export default function FeedItemCard({ item, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        width: '300px',
        cursor: 'pointer',
        border: '1px solid #ccc',
        borderRadius: '8px',
        overflow: 'hidden',
        backgroundColor: '#fff',
        transition: 'box-shadow 0.2s',
      }}
      onMouseEnter={e =>
        (e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.1)')
      }
      onMouseLeave={e => (e.currentTarget.style.boxShadow = '')}
    >
      <iframe
        src={`${item.postUrl}embed?cr=1&hidecaption=true`}
        frameBorder="0"
        scrolling="no"
        loading="lazy"
        style={{
          width: '100%',
          height: '300px',
          border: 'none',
          overflow: 'hidden',
        }}
        allowTransparency="true"
        title={item.title}
      />
      <div style={{ padding: '12px' }}>
        <h3
          style={{
            fontSize: '14px',
            fontWeight: '500',
            margin: '0 0 4px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textTransform: 'uppercase',
            color: '#333',
          }}
        >
          {item.title}
        </h3>
        <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>
          {new Date(item.publishedAt).toLocaleDateString()}
        </p>
      </div>
    </div>
  );
}
